import { render, staticRenderFns } from "./StatTile.vue?vue&type=template&id=1a583e86&"
import script from "./StatTile.vue?vue&type=script&lang=ts&"
export * from "./StatTile.vue?vue&type=script&lang=ts&"
import style0 from "./StatTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports